import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
} from 'antd'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectInsuranceArray } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateRangePayment,
  DateRangeChargeTypes,
  DateRangeType,
  DateSelect,
  getDateRange,
  DateRangeTypes,
} from '../../../compnents/form/DateSelect'
import { PaymentListParams } from '../../../services/payment'
import { ThemeContext } from '../../../theme/ThemeContext'
import { uploadOptions } from '../../InventoryChecking/query'
import { getAllDepartmentUser, selectDepartments } from './paymentSlice'
import {
  getpeopleList,
  selectPeopleList,
} from '../../nurse/pitest/pitestover/pitestSlice'
import { FilterColumn } from '../../../compnents/filterForm/filterForm'

export const PaymentQuery = (props: {
  filterColumn: any[]
  filterSelectList: any[]
  submitPageList: (params: any) => void
  onValueChange: (params: PaymentListParams) => void
  outExportExcel: () => void
  audit: () => void
  status: number
  YBZFUploadflag?: boolean
  selectedTab?: any
  LSCFSHflag?: boolean
  auditButtonLoading?:any
  loading?:any
  exportLoading?:any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const inputRef = useRef<any>(null)

  const { Option } = Select

  const location: any = useLocation()

  const departments = useSelector(selectDepartments)

  const insuranceArray = useSelector(selectInsuranceArray)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname) || '{}'
  )

  const [allList, setAllList] = useState<any>([])

  const loadData = (selectedOptions: any) => {
    const targetOption = selectedOptions[selectedOptions.length - 1]
    targetOption.loading = true
  }

  const peopleList = useSelector(selectPeopleList)
  useEffect(() => {
    if (props.status == 3) {
      dispatch(getpeopleList(10000))
    }
  }, [dispatch])

  const getAllDepartment = () => {
    dispatch(getAllDepartmentUser())
      .then(unwrapResult)
      .then((res: any) => {
        setAllList(
          res.map((v: any) => {
            return {
              label: v.name,
              value: v.id,
              children: v.children.map((i: any) => {
                return {
                  label: i.name,
                  value: i.id,
                }
              }),
            }
          })
        )
      })
  }

  useEffect(() => {
    getAllDepartment()
    if (
      Object.keys(storageParams).length &&
      props.status == storageParams.state
    ) {
      form.setFieldsValue({
        ...storageParams,
        // param: '', // 防止缓存数据输入
      })
      if (
        storageParams.treatmentDepartmentId &&
        storageParams.treatmentDoctorId
      ) {
        form.setFieldsValue({
          allData: [
            storageParams.treatmentDepartmentId,
            storageParams.treatmentDoctorId,
          ],
        })
      } else if (storageParams.treatmentDepartmentId) {
        form.setFieldsValue({
          allData: [storageParams.treatmentDepartmentId],
        })
      }
    } else {
      const [head, tail] = getDateRange(DateRangeType.Today)
      if(props?.status != 5) {
        form.setFieldsValue({
          registration_dateRange: 0,
          registrationTimeHead: head,
          registrationTimeTail: tail,
        })
      } else {
        form.setFieldsValue({
          refund_dateRange: 0,
          refundTimeHead: head,
          refundTimeTail: tail,
        })
      }
    }
    inputRef.current!.focus({
      //获取输入框焦点
      cursor: 'start',
    })
    // form.submit()
    refresh('session')
  }, [])

  const refresh = (flag = '') => {
    const tempArr = form.getFieldsValue().allData
    props.onValueChange({
      // ...storageParams,
      ...form.getFieldsValue(),
      treatmentDepartmentId: tempArr?.length ? tempArr[0] : undefined,
      treatmentDoctorId: tempArr?.length == 2 ? tempArr[1] : undefined,
      treatmentDepartmentName: tempArr?.length
        ? allList?.filter((v: any) => v.value == tempArr[0])[0]?.label
        : undefined,
      treatmentDoctorName:
        tempArr?.length == 2
          ? allList
              ?.filter((v: any) => v.value == tempArr[0])[0]
              ?.children?.filter((i: any) => i.value == tempArr[1])[0]?.label
          : undefined,
      allData: undefined,
      current: flag === 'session' ? Number(storageParams?.current || 1) : 1,
      size: Number(storageParams?.size || 10),
      state: props.status,
    })
  }

  return (
    <Form
      form={form}
      onFinish={(values) => {
        const data = props.status == storageParams.state ? storageParams : {}
        props.onValueChange({
          ...data,
          ...values,
          // current: data.current || 1,
          state: props.status,
          allData: undefined,
        })
      }}
    >
      <Row style={{ marginBottom: 10 }} justify='space-between'>
        <Space>
          <Form.Item noStyle name='param'>
            <Input
              ref={inputRef}
              autoComplete='off'
              maxLength={20}
              prefix={<SearchOutlined />}
              placeholder='患者姓名/手机号/病历号'
              style={{ width: '14rem' }}
              allowClear
              onChange={() => refresh()}
            />
          </Form.Item>
          <Form.Item noStyle name='allData'>
            <Cascaded
              loadData={loadData}
              changeOnSelect
              // suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
              style={{ width: '7rem' }}
              options={allList}
              onChange={() => refresh()}
              placeholder='科室列表'
            />
            {/* <Select
              style={{ width: '12.5rem' }}
              placeholder='查看范围-科室列表'
              allowClear
              onChange={refresh}
            >
              {departments.map((d) => (
                <Select.Option key={d.id} value={d.id}>
                  {d.name}
                </Select.Option>
              ))}
            </Select> */}
          </Form.Item>
          {insuranceArray &&
            insuranceArray.length !== 0 &&
            !props.YBZFUploadflag && (
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='险种类型'
                  style={{ width: '7rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={'ZIFEI'}>自费</Select.Option>
                  {insuranceArray.map((v) => (
                    <Select.Option value={v.insuranceCode} key={v.id}>
                      {v.insuranceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          {props.status == 3 && (
            <>
              <Form.Item name='paymentFlag' noStyle>
                <Select
                  placeholder='收费标志'
                  style={{ width: '7rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={1}>门诊</Select.Option>
                  <Select.Option value={2}>零售</Select.Option>
                  <Select.Option value={3}>挂号</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name='orderSource' noStyle>
                <Select
                  placeholder='订单来源'
                  style={{ width: '7rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={1}>挂号接诊</Select.Option>
                  <Select.Option value={2}>快速开单</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item name='payee' noStyle>
                <Select
                  placeholder='收款人'
                  style={{ width: '7rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  {peopleList.map((v: any) => {
                    return (
                      <Option value={v.id} key={v.id}>
                        {v.realname}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
              <Form.Item name='accountingStatus' noStyle>
                <Select
                  placeholder='结算状态'
                  style={{ width: '7rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  <Select.Option value={-1}>全部</Select.Option>
                  <Select.Option value={0}>已结清</Select.Option>
                  <Select.Option value={1}>欠费中</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item noStyle name='payMethodType'>
                <Select
                  placeholder='支付方式'
                  style={{ width: '7rem' }}
                  allowClear
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  <Select.Option value={1}>现金</Select.Option>
                  <Select.Option value={2}>聚合支付</Select.Option>
                  <Select.Option value={3}>支付宝</Select.Option>
                  <Select.Option value={4}>微信</Select.Option>
                  <Select.Option value={5}>银联</Select.Option>
                  <Select.Option value={6}>会员卡 </Select.Option>
                  <Select.Option value={99}>医保</Select.Option>
                  <Select.Option value={7}>其他 </Select.Option>
                </Select>
              </Form.Item>
            </>
          )}
          {props.YBZFUploadflag && (
            <Form.Item name='ybUploadFlag' noStyle>
              <Select
                placeholder='是否已上传'
                allowClear
                // suffixIcon={<CaretDownFilled />}
                style={{ width: '8rem' }}
                onChange={refresh}
              >
                {uploadOptions.map((v) => (
                  <Option value={v.value} key={v.value}>
                    {v.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          <DateSelect
            allowClear={props?.status == 5 ? true : false}
            style={{ width: props?.status == 5 ? '10rem' : '7rem' }}
            labelPrefix={props?.status == 5 ? '收费时间-' : ''}
            namePrefix='registrationTime'
            placeholder='时间'
            onlyTime="registration"
            options={ props?.status == 3 || props?.status == 5 ? DateRangePayment : DateRangeChargeTypes}
            // initialValue={DateRangeType.Today}
            onChange={() => refresh()}
          />
          {props?.status == 5 && <DateSelect
            allowClear={false}
            style={{ width: '10rem' }}
            labelPrefix='退费时间-'
            namePrefix='refundTime'
            placeholder='时间'
            options={ DateRangePayment}
            onlyTime="refund"
            // initialValue={DateRangeType.Today}
            onChange={() => refresh()}
          />}
          <Button type='primary' onClick={() => refresh()} loading={props?.loading}>
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
        <Space>
          {props?.selectedTab == 1 ? (
            <>
              <div style={{ color: '#999999' }}>
                （最多支持导出10000条数据，更多请联系客服）
              </div>
              <Button
                loading={props?.exportLoading}
                type='primary'
                onClick={() => {
                  props?.outExportExcel()
                }}
              >
                导出
              </Button>
            </>
          ) : (
            ''
          )}
          {props?.LSCFSHflag ? (
            <>
              <Button
                loading= {props?.auditButtonLoading}
                type='primary'
                onClick={() => {
                  props?.audit()
                }}
              >
                批量审核
              </Button>
            </>
          ) : (
            <></>
          )}
        </Space>
      </Row>
    </Form>
  )
}
